import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone } from 'lucide-react';
import Picture from '../site/Picture';
import { PHONE_HREF } from '../../siteConfig';

function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative isolate overflow-hidden bg-navy py-20 font-sans text-white lg:py-28">
      <Picture
        name="fleet-three-taxis-banner"
        alt=""
        width={1086}
        height={611}
        shimmer={false}
        className="absolute inset-0 -z-10 h-full w-full"
      />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-navy/80" />
      <div className="site-container flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h2 className="m-0 text-[28px] font-bold leading-tight tracking-tight lg:text-[44px]">{t('home.cta.title')}</h2>
          <p className="mb-0 mt-3 text-base text-slate-300 lg:text-lg">{t('home.cta.subtitle')}</p>
        </div>
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <Link to="/#book" className="btn-primary focus-ring-dark px-8">
            {t('home.cta.bookNow')}
          </Link>
          <a href={PHONE_HREF} className="btn-outline-white px-8">
            <Phone size={18} aria-hidden="true" />
            {t('home.cta.call')}
          </a>
        </div>
      </div>
    </section>
  );
}

export default CtaBanner;
